/**
 * Comportamenti «da app» (rimbalzo, tira per aggiornare, swipe indietro, aptici): solo nell'app nativa
 * (o con il flag di collaudo `localStorage.ml_native_ux = "1"` per provarli nel browser).
 */
import { Capacitor } from "@capacitor/core";

export function nativeUxEnabled(): boolean {
  try {
    return Capacitor.isNativePlatform() || localStorage.getItem("ml_native_ux") === "1";
  } catch {
    return Capacitor.isNativePlatform();
  }
}
